'use client';
import DashboardSideMenu from '@c/dashboard/DashboardSideMenu';
import DashboardLayoutBanners from 'app/dashboard/(dashboard)/components/DashboardLayoutBanners';
import MainContent from './components/MainContent';
import { Suspense } from 'react';

type Props = {
  children: React.ReactNode;
};

export default function DashboardLayout({ children }: Props) {
  return (
    <Suspense>
      <MainContent>
        <div className="mx-auto w-full max-w-[144rem]">
          <DashboardLayoutBanners />
          <div className="flex  min-h-[calc(100vh_-_8rem)] lg:min-h-[calc(100vh_-_14rem)] lg:px-default-padding-x lg:py-[4rem]">
            <div className="hidden lg:block">
              <DashboardSideMenu menuItemClicked={() => {}} />
            </div>
            <div className="w-full py-[1.2rem] ">{children}</div>
          </div>
        </div>
      </MainContent>
    </Suspense>
  );
}
